import localeEn from './en';

export default {
  ...localeEn,
  'Account': 'Konto',
  'Already with an account?': 'Bereits ein Konto?',
  'and': 'und',
  'Cancel subscription': 'Abonnement kündigen',
  'Catalogs': 'Kataloge',
  'Change profile picture': 'Profilbild ändern',
  'comingsoon': 'Diese Funktion kommt bald!',
  'Community': 'Gemeinschaft',
  'confirmed': 'bestätigt',
  'Connect': 'Verbinden',
  'Consent': 'Einverständnis',
  'copy': 'kopieren',
  'Copy': 'Kopieren',
  'Courses': 'Kurse',
  'Decline': 'Ablehnen',
  'Disconnect': 'Trennen',
  'Email': 'E-Mail',
  'Examples': 'Beispiele',
  'Features': 'Funktionen',
  'Filter categories': 'Kategorien filtern',
  'Firstname': 'Vorname',
  'Flightschool': 'Flugschule',
  'Home': 'Startseite',
  'I agree to the': 'Ich akzeptiere die ',
  'Imprint': 'Impressum',
  'Lastname': 'Nachname',
  'Learn': 'Lernen',
  'Learning': 'Lernen',
  'Lections': 'Lektionen',
  'Listening': 'Hören',
  'login': 'anmelden',
  'Login': 'Anmelden',
  'logout': 'Abmelden',
  'Mark as read': 'Als gelesen markieren',
  'month': 'Monat',
  'Month': 'Monat',
  'Monthly': 'monatlich',
  'or': 'oder',
  'password': 'Passwort',
  'Password': 'Passwort',
  'per': 'pro',
  'Phone': 'Telefon',
  'Positive': 'Positiv',
  'Pricing': 'Preise',
  'privacy': 'Datenschutz',
  'Privacy': 'Datenschutz',
  'privacyagreement': 'Ich stimme der Datenschutzvereinbarung und den Nutzungsbedingungen zu.',
  'product': 'Produkt',
  'Product': 'Produkt',
  'profile': 'Profil',
  'Question': 'Frage',
  'Questions': 'Fragen',
  'Read more': 'Mehr lesen',
  'Register': 'Registrieren',
  'Remove': 'Entfernen',
  'Report a bug': 'Fehler melden',
  'Request': 'Anfrage',
  'Resume subscription': 'Abonnement fortsetzen',
  'Scenarios': ' Szenarien',
  'School': 'Schule',
  'Search': 'Suche',
  'Seen': 'Gesehen',
  'Send': 'Senden',
  'Settings': 'Einstellungen',
  'Show hint again': 'Hinweis erneut anzeigen',
  'Simulator': 'Simulator',
  'Spelling': ' Rechtschreibung',
  'Studentarea': 'Schülerbereich',
  'Submit': 'Einreichen',
  'Subscription': 'Abonnement',
  'Tools': 'Werkzeuge',
  'tos': 'AGB',
  'Tos': 'Allgemeine Geschäftsbedingungen',
  'Total': 'Gesamt',
  'username': 'Nutzername',
  'Username': 'Nutzername',
  'Wiki': 'Wiki',
  'Write': 'Schreiben',
  'Year': 'Jahr',
  'Yearly': 'jährlich',
  'Your Name': 'Ihr Name',
  'Exam': 'Prüfung',
  'Unlimited': 'Unbegrenzt',
  'Time limit': 'Zeitlimit',
  'Started': 'Gestartet',
  'Completed': 'Abgeschlossen',
  'Percentage': 'Prozent',
  'Tries': 'Versuche',
  'License': 'Lizenz',
  'Exampreparation': 'Prüfungsvorbereitung',
  'Finish': 'Abschließen',
}
